import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Link, List, ListItem, ListItemText, Typography } from "@mui/material";
import { baseButtonStyle, dialogContent, iconAction, padding0, padding3 } from "../Styles";
import { IDListItem } from "./IdentityRequestShow";
import { MATCH_EVENT_TYPES_KEYS, MATCH_EVENT_TYPES_NAMES } from "../Constants";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { SimpleForm, TextInput } from "ra-ui-materialui";
import SimpleFormContainerComponent from "../common/SimpleFormContainerComponent";
import { useWatch } from 'react-hook-form';
import isEmpty from "lodash/isEmpty"
import { useDataProvider, useNotify, useRefresh } from "ra-core";
import { isAcknowledgeScreeningReportRole } from "../DataProvider";
import DownloadScreeningEvent from "./DownloadScreeningEvent";
import { useParams } from "react-router";

export const ScreeningEventDialog = (props) => {
  const {
    openDialog,
    closeDialog,
    event,
    id,
    reportId,
  } = props;

  const { clientId } = useParams();
   const isAcknowledgeScreeningReportRoleEnabled = isAcknowledgeScreeningReportRole();

  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      open={openDialog}
      onClose={closeDialog}
      fullWidth={true}
      PaperProps={{ fullScreen : true, fullWidth : true, style: { maxWidth: '800px' }}}
    >
      <DialogTitle display="flex" justifyContent="space-between">
        <Grid item>
          Match Details
        </Grid>
        <Grid item sx={{display:'flex', alignItems: 'center'}}>
          <DownloadScreeningEvent id={id} eventId={event?.id} reportId={reportId} userName={event?.name} clientId={clientId}>
          </DownloadScreeningEvent>
          <Button
            id="screening-event-close-button"
            onClick={closeDialog}
            sx={iconAction}
            size="large"
          >
            <CloseOutlinedIcon />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={dialogContent}>
        <EventGrid event={event} />
      </DialogContent>
      {isAcknowledgeScreeningReportRoleEnabled && event?.status !== MATCH_EVENT_TYPES_KEYS.REVIEWED &&
        <DialogActions sx={{...padding3.left, ...padding3.right, ...padding0.y}}>        
          <Grid container flexGrow={1}>
            <Grid item xs={12}>
              <List sx={padding0.y}>
                <IDListItem 
                  title="Acknowledge Reason"
                  value={
                  <SimpleForm
                    toolbar={null}
                    component={SimpleFormContainerComponent}
                  > 
                    <DialogActionsGrid id={id} reportId={reportId} eventId={event?.id} handleDialogClose={closeDialog} />
                  </SimpleForm>
                  } 
                />              
              </List>
            </Grid>
          </Grid>        
        </DialogActions>
      }
    </Dialog>
  );
}

export const EventGrid = ({ event }) => {
  return (
    <Grid container flexGrow={1}>
      <Grid item xs={12}>
        <List sx={padding0.y}>
          <IDListItem title="Name" value={event.name} />
          <Divider light />
          <IDListItem title="Birth Record" value={event.birthRecord} />
          <Divider light />
          <IDListItem title="Status" value={MATCH_EVENT_TYPES_NAMES[event.status]} />
          <Divider light />
          <IDListItem title="Summaries" value={            
            <List sx={padding0.y}>
              {event.summaries?.map((summary, index) => (
                <ListItem key={index} sx={{ padding: '4px 0', listStyleType: 'disc', display: 'list-item' }}>
                  <ListItemText primary={summary} disableTypography />
                </ListItem>
              ))}
            </List>
          }/>
          <Divider light />          
          <IDListItem title="Sources" value={
            <List sx={padding0.y}>
              {event.sources?.map((source, index) => (
                <ListItem key={index} sx={{ padding: '4px 0', listStyleType: 'disc', display: 'list-item' }}>
                  <ListItemText 
                    primary={source.referenceName} 
                    secondary={                      
                      <Typography noWrap>
                        <Link href={source.referenceUrl} target="_blank" rel="noopener noreferrer">
                          {source.referenceUrl}
                        </Link>
                      </Typography>
                    } 
                    disableTypography
                  />
                </ListItem>
              ))}
            </List>
          } />
          <Divider light />
          <IDListItem title="Acknowledgement Reason" value={event.reviewReason || "--"} />
          <Divider light />
          <IDListItem title="Reviewed By" value={event.reviewedBy || "N/A"} />
          <Divider light />
          <IDListItem title="Reviewed At" value={event.reviewedAt} />
          <Divider light />          
          <IDListItem title="Created At" value={event.created} />
          <Divider light />
          <IDListItem title="Last Modified" value={event.lastModified} />
          <Divider light />
        </List>
      </Grid>
    </Grid>
  );
};

export const DialogActionsGrid = ({ id, reportId, eventId, handleDialogClose }) => {
  const values = useWatch();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  
  const dismissMatch = () => {    
    dataProvider
    .acknowledgeScreeningReport({ id, reportId, eventId, acknowledgeReason: values?.acknowledgeReason })
    .then(() => {
      notify('Match acknowledged successfully', "info", { autoHideDuration: 1000 });
      refresh();
    })
    .catch(() => {
      notify('Something went wrong while acknowledging match', "warning", { autoHideDuration: 1000 });
    })
    .finally(() => {
      handleDialogClose();
    });
  }

  return (
    <Grid container alignItems="center">
      <Grid item xs={7}>
        <TextInput 
          source="acknowledgeReason" 
          variant="outlined" 
          fullWidth
          multiline
          label="Enter Reason"
          sx={{ marginTop : '25px' }}
        />
      </Grid>
      <Grid item xs={5}>        
        <Button
          id="screening-event-acknowledge-match-button"
          label="Acknowledge Match"
          size="medium"
          sx={{...baseButtonStyle()}}
          disabled={isEmpty(values.acknowledgeReason)}
          onClick={dismissMatch}
        >
          Acknowledge Match
        </Button>
      </Grid>
    </Grid>
  )
}